import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {Trades} from "../models/trades.model";
import {AngularFireStorage} from "@angular/fire/storage";
import {finalize} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TradesService {
  public uploadPercent: Observable<number>;
  private downloadURL: Observable<string | null>

  constructor(private firestore: AngularFirestore, private firestorage: AngularFireStorage) {
  }

  getTrade() {
    return this.firestore.collection("trades").snapshotChanges();
  }

  createTrade(trade: Trades){
    return this.firestore.collection('trades').add(trade);
  }

  updateTrade(trade: Trades){
    let position = trade.id;
    delete trade.id;
    this.firestore.doc('trades/' + position).update(trade);
  }

  deleteTrade(tradeID: string){
    this.firestore.doc('trades/' + tradeID).delete();
  }

  uploadFile(data: File, fileID: string) {
    const filePath = 'images/' + fileID + '.png';
    const fileRef = this.firestorage.ref(filePath);
    const task = this.firestorage.upload(filePath, data);
    // observe percentage changes
    this.uploadPercent = task.percentageChanges();
    // get notified when the download URL is available
    task.snapshotChanges().pipe(
        finalize(() => this.downloadURL = fileRef.getDownloadURL())).subscribe()
  }

  getDownloadURL(id: string){
    const filePath = 'images/' + id + '.png';
    const fileRef = this.firestorage.ref(filePath);
    return this.downloadURL = fileRef.getDownloadURL();
  }

}
